<template>
  <v-combobox
      v-model="model"
      :hint="label"
      :items="codes"
      :label="label"
      :search-input.sync="search"
      persistent-hint
      @change="$emit('change', model)"
  >
  </v-combobox>
</template>

<script>
import {input} from '@/mixins/input'

export default {
  mixins: [input],
  data() {
    return {
      isLoading: true,
      func: null,
      search: "",
      codes: []
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  watch: {
    search(newVal) {
      this.searchValue(newVal)
    }
  },
  mounted() {

  },
  methods: {
    searchValue(text){
      if(text == null || text == "" || this.field.options == undefined || this.field.options.relatedId == undefined){
        return
      }
      clearTimeout(this.func)

      this.func = setTimeout(()=>{
        let idSchema = this.field.options.relatedId
        this.$http.get(`related/schema/${idSchema}/values/search/${text}`).then(data =>{
          this.codes = data.data.map(relatedValues => relatedValues.code)
        }).catch(()=>{})
      }, 600)
    }
  },
}
</script>

<style>

</style>
